export default __webpack_public_path__ + "img/cbe-logo-plain.319f1101.png";